/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import useProcedure from '../../../../procedure/useProcedure';
import { attachmentTypes } from '../services/constants';
import { ConfigResourceProps } from '../../../../redux/enums/ConfigResourceProps';
import { useConfiguration } from '../../../../redux/features/configuration/useConfiguration';
import { filterAttachmentConfigByType } from '../services/attachments.helper';

/**
 * Hook to return the attachment types configurations,
 * based on the fo-configuration: /procedures/{procedureName}/config/attachmentTypes.json
 */
export function useAttachmentsConfig(unsupportedAttachmentTypes = []) {
  const procedure = useProcedure();
  const attachmentConfiguration = useConfiguration(ConfigResourceProps.ATTACHMENT_CONFIGURATION, procedure.id);
  const attachmentTypesConfig = attachmentConfiguration.resource?.attachmentTypes;
  const frontendCustomisationConfig = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);

  const technicalAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.TECHNICAL,
    unsupportedAttachmentTypes,
  );

  const additionalAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.ADDITIONAL,
    unsupportedAttachmentTypes,
  );

  const paymentAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.PAYMENT,
    unsupportedAttachmentTypes,
  );

  const bioMaterialAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.BIO_MATERIAL,
    unsupportedAttachmentTypes,
  );

  const seqListingAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.SEQ,
    unsupportedAttachmentTypes,
  );

  const spcAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.SPC,
    unsupportedAttachmentTypes,
  );

  const saAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    frontendCustomisationConfig?.resource?.customSA
      ? frontendCustomisationConfig?.resource?.customSA
      : attachmentTypes.SA,
    unsupportedAttachmentTypes,
  );

  const signatureAttachmentTypes = filterAttachmentConfigByType(
    attachmentTypesConfig,
    attachmentTypes.SIGNATURE,
    unsupportedAttachmentTypes,
  );

  return {
    attachmentsConfigReady: attachmentConfiguration.ready,
    attachmentTypesConfig,
    technicalAttachmentTypes,
    additionalAttachmentTypes,
    paymentAttachmentTypes,
    bioMaterialAttachmentTypes,
    seqListingAttachmentTypes,
    spcAttachmentTypes,
    saAttachmentTypes,
    signatureAttachmentTypes,
  };
}
